import { LocalizedElement } from '../i18n/Language';
import React from 'react';
import { Link } from '../i18n/links';
import policy from '../content/bookingPolicies.json';

export const policyLinks = [
{ path: '/terms', title: 'Booking Conditions' },
{ path: '/cancellation-policy', title: 'Cancellation Policy' },
{ path: '/refund-policy', title: 'Refund Policy' }];

export const cancellationAnswer = policy.customerCancellation.intro + ' ' +
policy.customerCancellation.schedule.map((tier) => tier.notice + ': ' + tier.percent + '% refund.').join(' ') +
' ' + policy.customerCancellation.paymentRule + ' ' + policy.customerCancellation.noticeRule;
export function PolicyLinks({ className = '' }) {
  return <LocalizedElement as="nav" aria-label="Booking policies" className={'flex flex-wrap gap-x-5 gap-y-3 text-sm ' + className}>
    {policyLinks.map((item) => <LocalizedElement as={Link} key={item.path} to={item.path} className="underline underline-offset-4 hover:text-blue-500 py-1">{item.title}</LocalizedElement>)}
  </LocalizedElement>;
}
export function CancellationSummary() {
  return <>
    <LocalizedElement as="section" aria-labelledby="customer-cancellation" className="space-y-4">
      <LocalizedElement as="h2" id="customer-cancellation" className="text-2xl font-semibold text-gray-900">Customer cancellation and refund schedule</LocalizedElement>
      <LocalizedElement as="p">{policy.customerCancellation.intro}</LocalizedElement>
      <LocalizedElement as="table" className="w-full table-fixed border-collapse text-left text-sm">
        <LocalizedElement as="caption" className="text-left font-semibold text-gray-900 pb-3">Refunds for bookings paid in full before cancellation</LocalizedElement>
        <thead><tr className="bg-blue-50"><LocalizedElement as="th" scope="col" className="border border-blue-100 p-3 w-3/4">Notice received before pickup</LocalizedElement><LocalizedElement as="th" scope="col" className="border border-blue-100 p-3">Amount refunded</LocalizedElement></tr></thead>
        <tbody>{policy.customerCancellation.schedule.map((tier) => <tr key={tier.percent}><LocalizedElement as="th" scope="row" className="border border-blue-100 p-3 font-normal">{tier.notice}</LocalizedElement><LocalizedElement as="td" className="border border-blue-100 p-3 font-bold text-blue-800">{tier.percent}%</LocalizedElement></tr>)}</tbody>
      </LocalizedElement>
      <LocalizedElement as="p">{policy.customerCancellation.paymentRule}</LocalizedElement>
      <LocalizedElement as="p">{policy.customerCancellation.noticeRule}</LocalizedElement>
    </LocalizedElement>
    <LocalizedElement as="section" aria-labelledby="company-cancellation" className="space-y-4 rounded-lg border border-blue-100 bg-blue-50 p-5">
      <LocalizedElement as="h2" id="company-cancellation" className="text-2xl font-semibold text-gray-900">Company cancellation or unprovided service</LocalizedElement>
      <LocalizedElement as="p">{policy.companyCancellation}</LocalizedElement>
    </LocalizedElement>
  </>;
}
